import { Button, Dialog, DialogContent, DialogTitle, Box, Typography, Divider, CircularProgress } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';
import CancelIcon from '@mui/icons-material/Cancel';
import VisibilityIcon from '@mui/icons-material/Visibility';

class ModalPreVisualizacaoCertidao extends ReactComponent {
    carregandoPreVisualizacaoCertidao = false;
    openDialogCertidao = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoPreVisualizacaoCertidao: observable,
            openDialogCertidao: observable,
            processosConfirmacaoPublicacao: computed,
            existeProcessoParaPublicacao: computed,
            datasPreVisualizacaoCertidao: computed,
            idPautaSelecionada: computed,
            enviarCertidao: computed,
            openModalCertidao: computed,
            abrirDialogVisualizacaoCertidao: action,
            handleCloseDialogCertidao: action,
            handleGerarPreCertidao: action,
            fecharModal: action,
            abrirModal: action
        });
    }

    get processosConfirmacaoPublicacao() {
        return this.observableProps.processosConfirmacaoPublicacao;
    }

    get existeProcessoParaPublicacao() {
        return this.observableProps.existeProcessoParaPublicacao;
    }

    get datasPreVisualizacaoCertidao() {
        return this.observableProps.datasPreVisualizacaoCertidao;
    }

    get idPautaSelecionada() {
        return this.observableProps.idPautaSelecionada;
    }

    get enviarCertidao() {
        return this.observableProps.enviarCertidao;
    }

    get openModalCertidao() {
        return this.observableProps.openModalCertidao;
    }

    async abrirDialogVisualizacaoCertidao(numeroProcesso) {
        this.openDialogCertidao = true;
        await this.handleGerarPreCertidao(numeroProcesso);
    }

    handleCloseDialogCertidao = () => {
        this.openDialogCertidao = false;
    };

    async handleGerarPreCertidao(numeroProcesso) {
        this.carregandoPreVisualizacaoCertidao = true;
        let response = await this.sessaoService.gerarPreVisualizacaoCertidao(
            this.pautaJulgamentoStore.idPautaSelecionada,
            numeroProcesso,
            this.datasPreVisualizacaoCertidao
        );
        runInAction(() => {
            this.previaCertidaoHTML = response;
        });
        this.carregandoPreVisualizacaoCertidao = false;
    }

    fecharModal = () => {
        this.observableProps.callbackCancelar();
    };

    abrirModal = () => {
        console.log(this.observableProps);
        this.observableProps.callbackAbrirModal();
    };

    render() {
        return (
            this.existeProcessoParaPublicacao && (
                <>
                    <Button
                        sx={{ cursor: 'pointer' }}
                        onClick={this.abrirModal}
                        color="primary"
                        variant="outlined"
                        disabled={!this.enviarCertidao}
                    >
                        Pré-visualizar
                    </Button>
                    <Dialog
                        open={this.openModalCertidao}
                        onClose={this.fecharModal}
                        maxWidth="md"
                        fullWidth={true}
                        sx={{ minHeight: '400px' }}
                    >
                        <DialogTitle>Pré-visualização da certidão</DialogTitle>
                        <DialogContent>
                            {this.processosConfirmacaoPublicacao.map((processo) => (
                                <Box key={processo.numeroProcesso}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '5px'
                                        }}
                                    >
                                        <Typography>{processo.processo.numeroCompleto}</Typography>
                                        <Button
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() =>
                                                this.abrirDialogVisualizacaoCertidao(processo.processo.numeroCompleto)
                                            }
                                            color="primary"
                                            variant="outlined"
                                            endIcon={<VisibilityIcon />}
                                            disabled={!this.enviarCertidao}
                                        >
                                            Visualizar certidão
                                        </Button>
                                    </Box>
                                    <Divider
                                        component="div"
                                        sx={{
                                            marginBottom: '5px'
                                        }}
                                    />
                                </Box>
                            ))}
                            <Box>
                                <Button
                                    sx={{ cursor: 'pointer', marginLeft: '87%' }}
                                    onClick={this.fecharModal}
                                    color="secondary"
                                    variant="outlined"
                                    endIcon={<CancelIcon />}
                                >
                                    Fechar
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.openDialogCertidao}
                        onClose={this.handleCloseDialogCertidao}
                        maxWidth="lg"
                        sx={{ minHeight: '400px' }}
                    >
                        <DialogTitle>Pré-visualização da certidão</DialogTitle>
                        <DialogContent>
                            {this.carregandoPreVisualizacaoCertidao ? (
                                <Box sx={{ textAlign: 'center' }}>
                                    <CircularProgress disableShrink />
                                </Box>
                            ) : (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            width: '100%',
                                            flexDirection: 'column',
                                            padding: '0px',
                                            textAlign: 'justify'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: this.previaCertidaoHTML }}
                                    ></Box>
                                    <Button
                                        sx={{ cursor: 'pointer', marginLeft: '90%' }}
                                        onClick={this.handleCloseDialogCertidao}
                                        color="secondary"
                                        variant="outlined"
                                        endIcon={<CancelIcon />}
                                    >
                                        Fechar
                                    </Button>
                                </>
                            )}
                        </DialogContent>
                    </Dialog>
                </>
            )
        );
    }
}

export default inject('stores')(observer(ModalPreVisualizacaoCertidao));
